/**
 * Commercial Optimization Configuration
 * Central configuration for the Commercial Optimization widget
 */

const commercialOptimizationConfig = {
  widget: {
    refreshInterval: 300000,
    enableMockData: true
  },
  layout: {
    title: "Commercial Optimization",
    direction: "row",
    gap: "40px",
    padding: "20px",
    backgroundColor: "#eee"
  },
  typography: {
    fontFamily: "Arial, sans-serif",
    title: {
      fontSize: "18px",
      fontWeight: "bold",
      color: "#333",
      marginBottom: "15px"
    },
    sectionTitle: {
      fontSize: "16px",
      fontWeight: "600",
      color: "#333",
      marginBottom: "10px"
    },
    controls: {
      fontSize: "14px",
      fontWeight: "500",
      color: "#333"
    },
    tableHeader: {
      fontSize: "12px",
      fontWeight: "bold",
      color: "#333"
    },
    tableBody: {
      fontSize: "12px",
      fontWeight: "normal",
      color: "#555"
    },
    updateInfo: {
      fontSize: "11px",
      fontWeight: "normal",
      color: "#666",
      fontStyle: "italic"
    },
    revenueUplift: {
      fontSize: "14px",
      fontWeight: "bold",
      color: "#0066cc"
    }
  },
  marketEnergyAllocation: {
    title: "Market Energy Allocation Risk Wise",
    riskLevels: ["Low Risk", "Medium Risk", "High Risk", "Very High Risk"],
    markets: ["Intra-day", "Reserve", "Day-Ahead", "PPA"],
    colors: {
      "Low Risk": "#a9c9c9",
      "Medium Risk": "#8f8a40", 
      "High Risk": "#e4c2b9",
      "Very High Risk": "#f8b5b5"
    },
    chart: {
      height: "300px",
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" }
      },
      legend: {
        top: 20,
        textStyle: { fontSize: 12 }
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true
      },
      yAxisLabel: "Energy Allocation (MWh)"
    }
  },
  optimalBiddingTable: {
    title: "Optimal Bidding Table",
    columns: [
      { key: "strategy", label: "Strategy", width: "150px", minWidth: "120px" },
      { key: "category", label: "Risk Category", width: "120px", minWidth: "100px" },
      { key: "bidAmount", label: "Bid Amount", width: "120px", minWidth: "100px", type: "currency" },
      { key: "expectedProfit", label: "Expected Profit", width: "130px", minWidth: "110px", type: "currency" },
      { key: "probability", label: "Probability (%)", width: "110px", minWidth: "90px", type: "percentage" },
      { key: "riskScore", label: "Risk Score", width: "100px", minWidth: "80px" },
      { key: "volume", label: "Volume (MWh)", width: "110px", minWidth: "90px" },
      { key: "efficiency", label: "Efficiency (%)", width: "110px", minWidth: "90px", type: "percentage" },
      { key: "status", label: "Status", width: "100px", minWidth: "80px" }
    ],
    riskThresholds: {
      high: 50000,
      medium: 10000
    }
  },
  controls: {
    riskLevels: ["All", "Low Risk", "Medium Risk", "High Risk", "Very High Risk"],
    defaultRisk: "Medium Risk",
    showRefreshButton: true
  },
  responsive: {
    breakpoints: {
      mobile: 480,
      tablet: 768,
      desktop: 1024
    },
    layout: {
      mobile: "vertical",
      tablet: "vertical", 
      desktop: "horizontal"
    }
  },
  api: {
    endpoints: {
      marketData: "/api/market-energy-allocation",
      biddingData: "/api/optimal-bidding"
    },
    timeout: 10000,
    retryAttempts: 3
  },
  accessibility: {
    chartDescription: "Market energy allocation chart showing risk-wise distribution across different markets",
    tableDescription: "Optimal bidding strategies table with risk analysis and performance metrics"
  }
};

export default commercialOptimizationConfig;
